
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Nonacbusrentalserviceinpune() {



    const cardData =
    {
        keyword: 'Non Ac Bus Rental Service in Pune',
        heading: 'Samarth Travels: Non Ac Bus Rental Service in Pune',
        headingDescription: 'Samarth Travels offers Non AC bus rental service in Pune, ideal for budget-friendly group travel, school trips, local sightseeing, and short-distance tours. Our well-maintained non-air-conditioned buses, available in 32-seater and 45-seater options, provide comfortable seating and spacious interiors for a smooth ride. With experienced drivers, economical pricing, and reliable service, Samarth Travels ensures a safe and affordable travel experience for all occasions.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

      "services": [
    {
      "name": "Non AC Bus for Hire for Outstation",
      "description": "Samarth Travels offers non-AC buses for hire from Pune to outstation destinations. Ideal for budget-conscious group travel, our non-air-conditioned buses provide ample seating, luggage space, and professional drivers for a safe and economical journey."
    },
    {
      "name": "Non AC Tempo Traveller on Rent Pune",
      "description": "Looking for an affordable travel solution? Our non-AC tempo travellers are perfect for short to mid-range trips from Pune, suitable for small groups, family functions, or religious tours."
    },
    {
      "name": "Non AC Bus Hire on Rent in Pune",
      "description": "Hire a non-AC bus in Pune with Samarth Travels for weddings, school picnics, or team outings. Our well-maintained buses ensure a comfortable and reliable ride at a competitive price."
    },
    {
      "name": "Non AC Mini Bus Hire on Rent in Pune",
      "description": "Book non-AC mini buses in Pune for local events, sightseeing, or airport transfers. Our mini buses are compact yet spacious, providing a smooth travel experience for small to medium-sized groups."
    },
    {
      "name": "Non AC Bus Hire for Picnic in Pune",
      "description": "Planning a picnic on a budget? Samarth Travels offers non-AC bus hire in Pune, ideal for school and college picnics, family outings, and team-building trips without compromising on safety or comfort."
    },
    {
      "name": "Best Bus Rental Service in Pune",
      "description": "Choose Samarth Travels for the best bus rental service in Pune. With options for both AC and non-AC, our fleet ranges from mini buses to 50-seaters, suitable for every occasion including picnics, weddings, and outstation travel."
    },
    {
      "name": "32, 35, 40, 45 Seater Local and Outstation Bus",
      "description": "Need large-capacity transport? We offer 32, 35, 40, and 45-seater buses for both local and outstation trips. Whether it’s a school trip, wedding, or corporate event, Samarth Travels provides well-maintained buses and trained drivers."
    },
    {
      "name": "14, 17, 20, 25 Seater Bus on Rent Pune",
      "description": "Samarth Travels offers a variety of smaller bus options — 14, 17, 20, and 25 seaters — available for rent in Pune. Ideal for mid-size groups traveling for events, pilgrimages, or weekend getaways."
    }
  ],
  "tableData": [
    ["Non AC Bus for Hire for Outstation", "Non AC Tempo Traveller on Rent Pune"],
    ["Non AC Bus Hire on Rent in Pune", "Non AC Mini Bus Hire on Rent in Pune"],
    ["Non AC Bus Hire for Picnic in Pune", "Best Bus Rental Service in Pune"],
    ["32, 35, 40, 45 Seater Local and Outstation Bus", "14, 17, 20, 25 Seater Bus on Rent Pune"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Non-AC Bus Rental Service in Pune",
        "WhyChoosedescription": "We offer reliable and budget-friendly non-AC bus rental services in Pune for all types of events and group travel. Ideal for short distances, local travel, and cost-conscious group transportation, our non-AC buses provide great value without compromising on comfort or safety."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Seating for All Group Sizes",
        "WhyChoosedescription": "Our non-AC buses come in multiple seating capacities—from minibuses to full-size coaches—perfect for school trips, office commutes, weddings, and group tours. Every vehicle is designed to offer ample space, ventilation, and comfortable seating for a pleasant journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "All our buses are operated by professional drivers who are experienced, courteous, and punctual. They are well-versed with routes in and around Pune and ensure smooth transportation for all group sizes and types of journeys."
    },
    {
        "WhyChooseheading": "Transparent and Flexible Pricing Plans",
        "WhyChoosedescription": "We provide non-AC bus rentals at competitive prices with no hidden charges. Our flexible rental plans—hourly, daily, or for specific trips—help you manage your travel needs within your budget."
    },
    {
        "WhyChooseheading": "24/7 Availability for All Travel Needs",
        "WhyChoosedescription": "Our non-AC bus rental service is available 24/7 to meet your specific travel schedule. Whether you need early morning transportation or a late-night return, we’re ready to serve whenever required."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Travel Coordination",
        "WhyChoosedescription": "Booking a non-AC bus is quick and hassle-free through our website or customer care. You'll receive real-time updates, driver details, and live bus tracking to help manage group logistics efficiently."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Non-AC Buses",
        "WhyChoosedescription": "Every non-AC bus is thoroughly cleaned, sanitized, and inspected before the journey. We ensure hygienic interiors and proper maintenance for a safe and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenience",
        "WhyChoosedescription": "We support all major payment modes including UPI, debit/credit cards, net banking, digital wallets, and cash. Secure and flexible payment options make booking easy and convenient for everyone."
    }
]






















    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a Non AC bus in Pune with Samarth Travels?',
        answer: 'Renting a Non AC bus in Pune is simple with Samarth Travels. Just contact us through our website or call our support team. Share your travel details, such as date, destination, and number of passengers—we’ll recommend the most suitable Non AC bus for your needs.',
    },
    {
        id: 2,
        question: 'What types of Non AC buses are available for rent?',
        answer: 'We offer a variety of Non AC buses including 22-seater, 32-seater, 40-seater, and 50-seater options. These buses are ideal for budget-friendly travel, school trips, local events, and short-distance tours.',
    },
    {
        id: 3,
        question: 'Are Non AC buses suitable for long trips?',
        answer: 'Yes, our Non AC buses are well-maintained and suitable for both short and long journeys. They feature comfortable seating, good ventilation, and ample luggage space, ensuring a smooth ride even without air conditioning.',
    },
    {
        id: 4,
        question: 'What are the rental charges for Non AC buses in Pune?',
        answer: 'Non AC bus rental charges start from ₹30/km, depending on the bus size and trip duration. We also offer local hourly packages for city travel. Contact us for a customized quote based on your itinerary.',
    },
    {
        id: 5,
        question: 'Is the bus rental inclusive of driver and fuel?',
        answer: 'Yes, all our Non AC bus rentals include an experienced driver and fuel costs. Additional charges such as tolls, parking, and permits (if any) are communicated clearly during the booking process.',
    },
    {
        id: 6,
        question: 'Can I hire a Non AC bus for events like weddings or picnics?',
        answer: 'Absolutely! Our Non AC buses are commonly used for group travel to weddings, picnics, school excursions, and other local events. We ensure punctual service and clean, comfortable buses.',
    },
    {
        id: 7,
        question: 'Do you provide support during the trip?',
        answer: 'Yes, we offer 24/7 support for all Non AC bus rentals. Our team is available to help with any route adjustments or unexpected changes during your journey.',
    },
];

const testimonials = [
    {
        name: 'Mr. Ramesh Waghmare',
        role: 'School Teacher',
        text: 'We booked a 40-seater Non AC bus from Samarth Travels for a school picnic. The bus was spacious, clean, and arrived on time. The kids had a great time, and we’re happy with the service.',
        image: '/img/testimonial/testi_nonac_ramesh.jpg',
    },
    {
        name: 'Ms. Aarti Jadhav',
        role: 'Wedding Coordinator',
        text: 'Samarth Travels provided a 50-seater Non AC bus for our wedding guest transport. The booking process was smooth, and the bus was reliable and comfortable. Perfect for budget travel.',
        image: '/img/testimonial/testi_nonac_aarti.jpg',
    },
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Bus Rental Service in Pune",
  "image": "https://samarthtravels.com/assets/images/non-ac-bus-rental-pune.jpg", // Replace with actual image URL
  "description": "Affordable Non-AC bus rental service in Pune by Samarth Travels. Choose from 14 to 45-seater buses and tempo travellers for outstation travel, picnics, and local use. Ideal for group travel at budget-friendly rates.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5461"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6400",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/non-ac-bus-rental-service-pune" // Replace with actual page URL
  }
};



    return (
        <div>


<Helmet>
  <title>Non AC Bus Rental Service in Pune | 14 to 45 Seater Bus Hire</title>
  <meta 
    name="description" 
    content="Book Non-AC buses for rent in Pune with Samarth Travels. Perfect for budget group travel, picnics, and outstation trips. Options include 14, 17, 20, 25, 32, 35, 40, and 45-seater buses and tempo travellers." 
  />
  <meta 
    name="keywords" 
    content="Non Ac bus for hire for Outstation, Non ac tempo traveller on rent Pune, Non Ac bus Hire on Rent in Pune, Non ac mini bus hire on rent in pune, non ac bus hire for picnic in pune, best bus rental service in Pune, 32 35 40 45 Seater Local and outstation Bus, 14 17 20 25 Seater bus on rent pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Nonacbusrentalserviceinpune;